<template>
  <div class="divide-y divide-gray-100">
    <div class="flex items-center space-x-2 px-4 py-2 text-sm font-semibold text-gray-700" v-if="label">
      <div>
        {{ label }}
      </div>
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps({
  label: {
    type: String,
    required: false,
  },
})
</script>
